export const API_BASE = process.env.REACT_APP_BASIC_URL_WEB;
export const API_BASE_ATHENEUM = process.env.REACT_APP_BASIC_URL_BUZZ_ONE_V1;
export const API_BASE_BUZZONE = process.env.REACT_APP_BASIC_URL_BUZZ_ONE_V1;
export const AKADEMY_ONBOARDING_APP_URL =
  process.env.REACT_APP_BASIC_URL_AKADEMY_ONBOARDING_APP;
export const uploadDocSize = 2000000;
export const AUTH_TOKEN = localStorage.getItem('buzzToken');

// buzzone-api hosts are dev preschool-curriculum.in, staging beanstalkedu.in, production
// app.buzzapp.tech (buzz-pwa-app-react utils/helper.js). BCC itself is served from
// bcc.buzzapp.tech, the URL its invite email gives new users.
const PRODUCTION_API_HOST = 'app.buzzapp.tech';
const PRODUCTION_APP_HOSTS = ['app.buzzapp.tech', 'bcc.buzzapp.tech'];

const hostOf = (url) => {
  try {
    return new URL(url).hostname;
  } catch (e) {
    return '';
  }
};

/**
 * True when this build talks to production data, whichever way it got there: a production
 * deploy, or a local build whose .env points at the production API. Errs towards true —
 * it gates writes, and a wrongly read-only screen is the cheaper mistake.
 */
export const isProductionEnv = () =>
  hostOf(API_BASE_BUZZONE) === PRODUCTION_API_HOST ||
  PRODUCTION_APP_HOSTS.includes(window.location.hostname);
